<template>
  <el-form
    :model="queryParams"
    :rules="rules"
    ref="ruleForm"
    class="demo-ruleForm"
    v-loading="loading"
  >
    <div class="content">
      <!-- <p class="text">情况明细</p> -->
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="24">
          <p class="text">情况明细</p>
        </el-col>
        <el-col :span="24">
          <el-form-item label="" label-width="18%">
            <div class="select_box flex flex-justify">
              <div>企业职工</div>
              <div>科技人员</div>
            </div>
          </el-form-item>
          <el-form-item label="总数(人)" :required="true"  label-width="18%">
            <div class="select_box">
              <el-form-item prop="highTechApprovalManpowerResourceBO.empTotalAmount">
                <el-input-number disabled :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.empTotalAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
              <el-form-item prop="highTechApprovalManpowerResourceBO.sciTotalAmount">
                <el-input-number disabled :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.sciTotalAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="在职人员(人)" :required="true"  label-width="18%">
            <div class="select_box">
              <el-form-item prop="highTechApprovalManpowerResourceBO.empOnJobAmount">
                <el-input-number @input="numberInput" @blur="onInputFocus" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.empOnJobAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
              <el-form-item prop="highTechApprovalManpowerResourceBO.sciOnJobAmount">
                <el-input-number @input="numberInput" @blur="onInputFocus" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.sciOnJobAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="兼职人员(人)" :required="true"  label-width="18%">
            <div class="select_box">
              <el-form-item prop="highTechApprovalManpowerResourceBO.empParttimeJobAmount">
                <el-input-number @input="numberInput" @blur="onInputFocus" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.empParttimeJobAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
              <el-form-item prop="highTechApprovalManpowerResourceBO.sciParttimeJob">
                <el-input-number @input="numberInput" @blur="onInputFocus" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.sciParttimeJob" placeholder="请输入"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="临时聘用人员(人)" :required="true"  label-width="18%">
            <div class="select_box">
              <el-form-item prop="highTechApprovalManpowerResourceBO.empTemporaryAmount">
                <el-input-number @input="numberInput" @blur="onInputFocus" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.empTemporaryAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
              <el-form-item prop="highTechApprovalManpowerResourceBO.sciTemporaryAmount">
                <el-input-number @input="numberInput" @blur="onInputFocus" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.sciTemporaryAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="外籍人员(人)" :required="true" label-width="18%">
            <div class="select_box">
              <el-form-item prop="highTechApprovalManpowerResourceBO.empForeignAmount">
                <el-input-number @input="numberInput" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.empForeignAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
              <el-form-item prop="highTechApprovalManpowerResourceBO.sciForeignAmount">
                <el-input-number @input="numberInput" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.sciForeignAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="留学归国人员(人)" :required="true" label-width="18%">
            <div class="select_box">
              <el-form-item prop="highTechApprovalManpowerResourceBO.empAbroadAmount">
                <el-input-number @input="numberInput" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.empAbroadAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
              <el-form-item prop="highTechApprovalManpowerResourceBO.sciAbroadAmount">
                <el-input-number @input="numberInput" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.sciAbroadAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="千人计划人员(人)" :required="true" label-width="18%">
            <div class="select_box">
              <el-form-item prop="highTechApprovalManpowerResourceBO.empThousandPlanAmount">
                <el-input-number @input="numberInput" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.empThousandPlanAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
              <el-form-item prop="highTechApprovalManpowerResourceBO.sciThousandPlanAmount">
                <el-input-number @input="numberInput" :controls="false" v-model="queryParams.highTechApprovalManpowerResourceBO.sciThousandPlanAmount" placeholder="请输入"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <p class="text">全体人员结构</p>
        </el-col>
        <el-col :span="24">
          <el-form-item label="学历人数" :required="true">
          </el-form-item>
          <div class="people">
            <div>
              <div class="txt">博士</div>
              <div>
                <el-form-item prop="manpowerResourceEducationStructureBO.drNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceEducationStructureBO.drNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">硕士</div>
              <div>
                <el-form-item prop="manpowerResourceEducationStructureBO.masterNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceEducationStructureBO.masterNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">本科</div>
              <div>
                <el-form-item prop="manpowerResourceEducationStructureBO.bachelorNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceEducationStructureBO.bachelorNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">大专及以下</div>
              <div>
                <el-form-item prop="manpowerResourceEducationStructureBO.juniorNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceEducationStructureBO.juniorNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="24">
          <el-form-item label="职称人数" :required="true">
          </el-form-item>
          <div class="people">
            <div>
              <div class="txt">高级职称</div>
              <div>
                <el-form-item prop="manpowerResourceTitleStructureBO.highTitleNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceTitleStructureBO.highTitleNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">中级职称</div>
              <div>
                <el-form-item prop="manpowerResourceTitleStructureBO.mediumTitleNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceTitleStructureBO.mediumTitleNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">初级职称</div>
              <div>
                <el-form-item prop="manpowerResourceTitleStructureBO.juniorTitleNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceTitleStructureBO.juniorTitleNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">高级技工</div>
              <div>
                <el-form-item prop="manpowerResourceTitleStructureBO.seniorArtisanNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceTitleStructureBO.seniorArtisanNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-col>


        <el-col :span="24">
          <el-form-item label="年龄人数" :required="true">
          </el-form-item>
          <div class="people">
            <div>
              <div class="txt">30以下</div>
              <div>
                <el-form-item prop="manpowerResourceAgeStructureBO.underThirtyNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceAgeStructureBO.underThirtyNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">31-40</div>
              <div>
                <el-form-item prop="manpowerResourceAgeStructureBO.thirtyOneToFortyNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceAgeStructureBO.thirtyOneToFortyNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">41-50</div>
              <div>
                <el-form-item prop="manpowerResourceAgeStructureBO.fortyOneToFiftyNumber">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceAgeStructureBO.fortyOneToFiftyNumber" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="txt">51及以上</div>
              <div>
                <el-form-item prop="manpowerResourceAgeStructureBO.fiftyOneAndAbove">
                  <el-input-number @input="numberInput" :controls="false" v-model="queryParams.manpowerResourceAgeStructureBO.fiftyOneAndAbove" placeholder="请填写"></el-input-number>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="24" style="margin-top:20px;">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="uploadImgUrl"
            :on-success="quillImgSuccess"
            :on-preview="handleView"
            :on-remove="handleRemove"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            :data="{'moduleType':2}"
            accept="application/pdf,.xls,.xlsx"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">附件：请上传企业职工和科技人员情况说明材料，包括在职、兼职和临时聘用人员人数、人员学历结构、科技人员名单及其工作岗位等。文件类型：PDF,XLS,XLSX</div>
          </el-upload>
        </el-col>


      </el-row>
    </div>

    <el-row type="flex" justify="center" class="button_box">
      <el-col :span="6">
        <el-button type="primary" round @click="classSubmitForm(1)" :disabled="disabled">保存</el-button>
      </el-col>
      <el-col :span="6">
        <el-tooltip class="item" effect="light" content="操作点击上方步骤导航栏可跳转至对应页面填写信息" placement="top">
          <el-button round @click="classSubmitForm(2)" :disabled="disabled">下一步</el-button>
        </el-tooltip>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
    import { humanResourceQuery, humanResourceSave, getModuleFiles } from '@/api/ChinaHigh';

    export default {
        name: "manpowerForm",
        props: {
            id: {
                type: String,
                default: ''
            }
        },
        data() {
            var validateSciTotalAmount =  (rule, value, callback) => {
                if (this.queryParams.highTechApprovalManpowerResourceBO.empTotalAmount === '') {
                    callback(new Error('请输入企业职工总数'));
                } else {
                    if (this.queryParams.highTechApprovalManpowerResourceBO.empTotalAmount < value) {
                        callback(new Error('科技人员总数不能大于企业职工总数'));
                    }
                    callback();
                }
            };
            var validateSciOnJobAmount =  (rule, value, callback) => {
                if (this.queryParams.highTechApprovalManpowerResourceBO.empOnJobAmount === '') {
                    callback(new Error('请输入企业职工在职人员'));
                } else {
                    if (this.queryParams.highTechApprovalManpowerResourceBO.empOnJobAmount < value) {
                        callback(new Error('科技人员在职人员不能大于企业职工在职人员'));
                    }
                    callback();
                }
            };
            var validateSciParttimeJob =  (rule, value, callback) => {
                if (this.queryParams.highTechApprovalManpowerResourceBO.empParttimeJobAmount === '') {
                    callback(new Error('请输入企业职工兼职人员'));
                } else {
                    if (this.queryParams.highTechApprovalManpowerResourceBO.empParttimeJobAmount < value) {
                        callback(new Error('科技人员兼职人员不能大于企业职工兼职人员'));
                    }
                    callback();
                }
            };
            var validateSciTemporaryAmount =  (rule, value, callback) => {
                if (this.queryParams.highTechApprovalManpowerResourceBO.empTemporaryAmount === '') {
                    callback(new Error('请输入企业职工临时聘用人员'));
                } else {
                    if (this.queryParams.highTechApprovalManpowerResourceBO.empTemporaryAmount < value) {
                        callback(new Error('科技人员临时聘用人员不能大于企业职工临时聘用人员'));
                    }
                    callback();
                }
            };
            var validateSciForeignAmount =  (rule, value, callback) => {
                if (this.queryParams.highTechApprovalManpowerResourceBO.empForeignAmount === '') {
                    callback(new Error('请输入企业职工外籍人员'));
                } else {
                    if (this.queryParams.highTechApprovalManpowerResourceBO.empForeignAmount < value) {
                        callback(new Error('科技人员外籍人员不能大于企业职工外籍人员'));
                    }
                    callback();
                }
            };
            var validateSciAbroadAmount =  (rule, value, callback) => {
                if (this.queryParams.highTechApprovalManpowerResourceBO.empAbroadAmount === '') {
                    callback(new Error('请输入企业职工留学归国人员'));
                } else {
                    if (this.queryParams.highTechApprovalManpowerResourceBO.empAbroadAmount < value) {
                        callback(new Error('科技人员留学归国人员不能大于企业职工留学归国人员'));
                    }
                    callback();
                }
            };
            var validateSciThousandPlanAmount =  (rule, value, callback) => {
                if (this.queryParams.highTechApprovalManpowerResourceBO.empThousandPlanAmount === '') {
                    callback(new Error('请输入企业职工千人计划人员'));
                } else {
                    if (this.queryParams.highTechApprovalManpowerResourceBO.empThousandPlanAmount < value) {
                        callback(new Error('科技人员千人计划人员不能大于企业职工千人计划人员'));
                    }
                    callback();
                }
            };
            var validateEmpSum =  (rule, value, callback) => {
                var ht = this.queryParams.highTechApprovalManpowerResourceBO;
                // value = ht.empOnJobAmount + ht.empParttimeJobAmount + ht.empTemporaryAmount;
                // if (value <
                //     ht.empOnJobAmount + ht.empParttimeJobAmount + ht.empTemporaryAmount+ ht.empForeignAmount + ht.empAbroadAmount +ht.empAbroadAmount) {
                //     callback(new Error('企业总人数过少'));
                // } else {
                //     callback();
                // }
            };
            var validateSciSum =  (rule, value, callback) => {
                var ht = this.queryParams.highTechApprovalManpowerResourceBO;
                // if (value <
                //     ht.sciOnJobAmount + ht.sciParttimeJob + ht.sciTemporaryAmount+ ht.sciForeignAmount + ht.sciAbroadAmount +ht.sciThousandPlanAmount) {
                //     callback(new Error('科技总人数过少'));
                // } else {
                //     callback();
                // }
            };
            return {
                loading:false,
                queryParams: {
                    fileBOList: [],
                    highTechApprovalManpowerResourceBO: {},
                    manpowerResourceAgeStructureBO: {},
                    manpowerResourceEducationStructureBO: {},
                    manpowerResourceTitleStructureBO: {}
                },
                rules: {
                    'highTechApprovalManpowerResourceBO.empTotalAmount': [
                        // {required: true, message: "请输入企业职工总数", trigger: "blur"},
                        // { validator: validateEmpSum, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.sciTotalAmount': [
                        // {required: true, message: "请输入科技人员总数", trigger: "blur"},
                        // { validator: validateSciTotalAmount, trigger: 'blur' },
                        // { validator: validateSciSum, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.empOnJobAmount': [
                        {required: true, message: "请输入企业职工在职人员", trigger: "blur"},
                        // { min: 1, max: 12, message: '长度在 1 到 12 个字符', trigger: 'blur' },
                        { validator: validateSciOnJobAmount, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.sciOnJobAmount': [
                        {required: true, message: "请输入科技人员在职人员", trigger: "blur"},
                        { validator: validateSciOnJobAmount, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.empParttimeJobAmount': [
                        {required: true, message: "请输入企业职工兼职人员", trigger: "blur"},
                    ],
                    'highTechApprovalManpowerResourceBO.sciParttimeJob': [
                        {required: true, message: "请输入科技人员兼职人员", trigger: "blur"},
                        { validator: validateSciParttimeJob, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.empTemporaryAmount': [
                        {required: true, message: "请输入企业职工临时聘用人员", trigger: "blur"},
                    ],
                    'highTechApprovalManpowerResourceBO.sciTemporaryAmount': [
                        {required: true, message: "请输入科技人员临时聘用人员", trigger: "blur"},
                        { validator: validateSciTemporaryAmount, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.empForeignAmount': [
                        {required: true, message: "请输入企业职工外籍人员", trigger: "blur"},
                    ],
                    'highTechApprovalManpowerResourceBO.sciForeignAmount': [
                        {required: true, message: "请输入科技人员外籍人员", trigger: "blur"},
                        { validator: validateSciForeignAmount, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.empAbroadAmount': [
                        {required: true, message: "请输入企业职工留学归国人员", trigger: "blur"},
                    ],
                    'highTechApprovalManpowerResourceBO.sciAbroadAmount': [
                        {required: true, message: "请输入科技人员留学归国人员", trigger: "blur"},
                        { validator: validateSciAbroadAmount, trigger: 'blur' }
                    ],
                    'highTechApprovalManpowerResourceBO.empThousandPlanAmount': [
                        {required: true, message: "请输入企业职工千人计划人员", trigger: "blur"},
                    ],
                    'highTechApprovalManpowerResourceBO.sciThousandPlanAmount': [
                        {required: true, message: "请输入科技人员千人计划人员", trigger: "blur"},
                        { validator: validateSciThousandPlanAmount, trigger: 'blur' }
                    ],
                    'manpowerResourceEducationStructureBO.drNumber': [
                        {required: true, message: "请输入博士人数", trigger: "blur"},
                    ],
                    'manpowerResourceEducationStructureBO.masterNumber': [
                        {required: true, message: "请输入硕士人数", trigger: "blur"},
                    ],
                    'manpowerResourceEducationStructureBO.bachelorNumber': [
                        {required: true, message: "请输入本科人数", trigger: "blur"},
                    ],
                    'manpowerResourceEducationStructureBO.juniorNumber': [
                        {required: true, message: "请输入大专及以下人数", trigger: "blur"},
                    ],
                    'manpowerResourceTitleStructureBO.highTitleNumber': [
                        {required: true, message: "请输入高级职称人数", trigger: "blur"},
                    ],
                    'manpowerResourceTitleStructureBO.mediumTitleNumber': [
                        {required: true, message: "请输入中级职称人数", trigger: "blur"},
                    ],
                    'manpowerResourceTitleStructureBO.juniorTitleNumber': [
                        {required: true, message: "请输入初级职称人数", trigger: "blur"},
                    ],
                    'manpowerResourceTitleStructureBO.seniorArtisanNumber': [
                        {required: true, message: "请输入高级技工人数", trigger: "blur"},
                    ],
                    'manpowerResourceAgeStructureBO.underThirtyNumber': [
                        {required: true, message: "请输入30及以下人数", trigger: "blur"},
                    ],
                    'manpowerResourceAgeStructureBO.thirtyOneToFortyNumber': [
                        {required: true, message: "请输入31-40人数", trigger: "blur"},
                    ],
                    'manpowerResourceAgeStructureBO.fortyOneToFiftyNumber': [
                        {required: true, message: "请输入41-50人数", trigger: "blur"},
                    ],
                    'manpowerResourceAgeStructureBO.fiftyOneAndAbove': [
                        {required: true, message: "请输入51及以上人数", trigger: "blur"},
                    ],
                },
                fileList: [],
                disabled: false,
            }
        },
        created() {
            this.chushi()
        },
        methods: {
            chushi() {
                this.queryParams = {
                    fileBOList: [],
                    highTechApprovalManpowerResourceBO: {},
                    manpowerResourceAgeStructureBO: {},
                    manpowerResourceEducationStructureBO: {},
                    manpowerResourceTitleStructureBO: {}
                }
                this.fileList = []
                this.resetFiles('upload');
                this.resetForm('ruleForm');
                this.getList()
            },
            getList () {
                humanResourceQuery(this.id).then(res => {
                    if (res.data !== null && res.data !== '' && res.data !== undefined && JSON.stringify(res.data) !== "{}") {
                        this.queryParams.highTechApprovalManpowerResourceBO = res.data.highTechApprovalManpowerResourceBO;
                        this.queryParams.manpowerResourceAgeStructureBO = res.data.manpowerResourceAgeStructureBO;
                        this.queryParams.manpowerResourceEducationStructureBO = res.data.manpowerResourceEducationStructureBO;
                        this.queryParams.manpowerResourceTitleStructureBO = res.data.manpowerResourceTitleStructureBO;
                        getModuleFiles({ 'moduleId': res.data.highTechApprovalManpowerResourceBO.approvalId, 'moduleType': 2 }).then(res => {
                            this.queryParams.fileBOList = res.data;
                            res.data.forEach(re => {
                                this.fileList.push({"name": re.fileName, "fileName": re.fileName, "url": re.url, "moduleId": re.moduleId, "moduleType": re.moduleType, "path": re.path, 'id': re.id})
                            })
                        })
                    }
                })
            },
            numberInput(val){
              console.log(val);
              if(String(val).length >= 12){
                this.$message.error("输入长度过长");
              }
            },
            onInputFocus(){
              console.log("+++++++")
                this.queryParams.highTechApprovalManpowerResourceBO.empTotalAmount =
                this.queryParams.highTechApprovalManpowerResourceBO.empOnJobAmount+this.queryParams.highTechApprovalManpowerResourceBO.empParttimeJobAmount+this.queryParams.highTechApprovalManpowerResourceBO.empTemporaryAmount;
                this.queryParams.highTechApprovalManpowerResourceBO.sciTotalAmount =
                this.queryParams.highTechApprovalManpowerResourceBO.sciOnJobAmount+this.queryParams.highTechApprovalManpowerResourceBO.sciTemporaryAmount+this.queryParams.highTechApprovalManpowerResourceBO.sciParttimeJob;
            },
            classSubmitForm (status) {
                this.queryParams.highTechApprovalManpowerResourceBO.empTotalAmount =
                this.queryParams.highTechApprovalManpowerResourceBO.empOnJobAmount+this.queryParams.highTechApprovalManpowerResourceBO.empParttimeJobAmount+this.queryParams.highTechApprovalManpowerResourceBO.empTemporaryAmount;
                this.queryParams.highTechApprovalManpowerResourceBO.sciTotalAmount =
                this.queryParams.highTechApprovalManpowerResourceBO.sciOnJobAmount+this.queryParams.highTechApprovalManpowerResourceBO.sciTemporaryAmount+this.queryParams.highTechApprovalManpowerResourceBO.sciParttimeJob;

                // if(this.queryParams.manpowerResourceEducationStructureBO.drNumber+this.queryParams.manpowerResourceEducationStructureBO.masterNumber+this.queryParams.manpowerResourceEducationStructureBO.bachelorNumber+this.queryParams.manpowerResourceEducationStructureBO.juniorNumber != this.queryParams.highTechApprovalManpowerResourceBO.empTotalAmount){
                //   this.$message({
                //     showClose: true,
                //     message: '学历四项之和应该等于职工总数',
                //     type: 'warning'
                //   })
                // }
                // if(this.queryParams.manpowerResourceAgeStructureBO.underThirtyNumber+this.queryParams.manpowerResourceAgeStructureBO.thirtyOneToFortyNumber+this.queryParams.manpowerResourceAgeStructureBO.fortyOneToFiftyNumber+this.queryParams.manpowerResourceAgeStructureBO.fiftyOneAndAbove != this.queryParams.highTechApprovalManpowerResourceBO.sciTotalAmount){
                //   this.$message({
                //     showClose: true,
                //     message: '年龄四项之和应该等于职工总数',
                //     type: 'warning'
                //   })
                // }



                // this.queryParams.highTechApprovalManpowerResourceBO.sciTotalAmount =
                // this.queryParams.manpowerResourceTitleStructureBO.highTitleNumber+this.queryParams.manpowerResourceTitleStructureBO.mediumTitleNumber+this.queryParams.manpowerResourceTitleStructureBO.juniorTitleNumber+this.queryParams.manpowerResourceTitleStructureBO.seniorArtisanNumber;
                var files = this.$refs.upload.uploadFiles;
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        if(files.length <= 0){
                            this.msgError("请上传附件！");
                        } else {
                            this.queryParams.highTechApprovalManpowerResourceBO.approvalId = this.id
                            humanResourceSave(this.queryParams).then(res => {
                                if (res.code === "00000") {
                                    this.chushi()
                                    this.msgSuccess(res.msg)
                                    if(status === 2) {
                                        this.$emit('step',4)
                                    }
                                }
                            })
                        }
                    } else {
                        return false;
                    }
                })
            },
            beforeUpload(file,fileList) {
                let suffix=file.name.substring(file.name.lastIndexOf(".")+1);
                if (suffix!='pdf'&&suffix!='xls'&&suffix!='xlsx'){
                    this.msgError("只能上传pdf/xls/xlsx格式的文件");

                    return false;
                }else{
                  //  this.loading=true;
                }

            },
            // 上传成功
            quillImgSuccess(res, file, fileList) {
                this.loading=false;
                // 如果上传成功
                if (res.code === '00000') {
                    this.queryParams.fileBOList.push(res.data);
                    this.msgSuccess("附件上传成功");
                } else {
                    this.msgError("附件上传失败");
                }
                let status = ''
                fileList.some(res => {
                    if(res.status != 'success'){
                        status = 1;
                        return ;
                    }
                })
            },
            // 图片删除
            handleRemove(file, fileList) {
                this.queryParams.fileBOList = [];
                console.log(fileList);
                fileList.forEach(res => {
                    if(res.response == undefined){
                        this.queryParams.fileBOList.push(res)
                    } else {
                        this.queryParams.fileBOList.push(res.response.data)
                    }
                })
                if (this.queryParams.fileBOList.length<=0){
                    this.queryParams.fileBOList.push({moduleType:2,moduleId:this.id});
                }
                console.log(this.queryParams.fileBOList);
            },
            // 富文本图片上传失败
            uploadError(err, file, fileList) {
                this.loading=false;
                if(fileList.length> 0) {
                    let status = ''
                    fileList.some(res => {
                        if(res.status != 'success'){
                            status = 1;
                            return ;
                        }
                    })
                    if (status != 1) {
                        this.disabled = false
                    }
                } else {
                    this.disabled = false;
                }
                // loading动画消失
                this.msgError("图片上传失败");
            },
        }
    }
</script>

<style scoped>
  .people{
    margin-left: 10%;
    display: flex;
    justify-content: space-between;
  }
  .people>div{
    width: 22%;
    display: flex;
    flex-wrap: wrap;
  }
  .people>div .txt{
    width: 100%;
    margin-bottom: 10px;
  }
  .flex .el-button {
    margin-bottom: 10px;
  }
  .button_box {
    margin-top: 20px;
  }
  .button_box button {
    padding: 10px 60px;
  }
  .image {
    width: 100%;
    height: auto;
  }
  .select_box {
    display: flex;
    justify-content: flex-start;
  }
  .select_box .el-select,
  .select_box .el-input,
  .select_box > div {
    width: 30%;
    margin-left: 20px;
  }


  .wrap {
    width: 84%;
    margin-left: 16%;
  }

  .row-bg {
    width: 84%;
    margin: 0 auto;
    flex-wrap: wrap;
  }

  .content {
    margin-top: 30px;
    background: #fff;
    width: 100%;
    padding-bottom: 20px;
  }
  .content .text {
    font-size: 13px;
    border-bottom: 1px solid #d4d4d4;
    position: relative;
  }
  .content p {
    font-size: 13px;
    padding: 10px 20px;
  }
  .content .text::before {
    content: "";
    position: absolute;
    width: 4px;
    height: 18px;
    left: 10px;
    top: 10px;
    background: #7c99fd;
  }
  .el-table .cell {
    white-space: pre-line;
  }
  .el-select {
    width: 100%;
  }
  .accessory_box {
    width: 100%;
    margin-top: 10px;
  }
  .accessory_box > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
  }

</style>
